module.exports = __webpack_public_path__ + "img/pencil-filters_cn.1d91398.jpg";